export default "__VITE_ASSET__xWbq57WT__"